import { useEffect, useState } from "react";

import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  formControl: { backgroundColor: theme?.palette?.background.paper },
  category: {
    color: theme?.palette?.secondary?.main,
    fontWeight: "bold",
    opacity: "1 !important"
  },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex"
    }
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function GenericMultiSelect(props) {
  const {
    name,
    label,
    list,
    listDict,
    value,
    setFieldValue,
    touched,
    error,
    formControlSX,
    endAdornment,
    disabled
  } = props;
  const classes = useStyles();
  const [items, setItems] = useState([]);

  const handleSelect = (event) => {
    const {
      target: { value }
    } = event;
    setFieldValue(
      name,
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  useEffect(() => {
    const check = async () => {
      var itemArray = [];
      if (list) {
        list.forEach((item, index) => {
          if (item.children?.length > 0) {
            itemArray.push(
              <MenuItem
                disabled
                value=""
                sx={{
                  color: "secondary.main",
                  fontWeight: "bold",
                  opacity: "1 !important"
                }}
              >
                {item.label}
              </MenuItem>
            );
            item.children.forEach((child, childIndex) => {
              itemArray.push(
                <MenuItem
                  key={childIndex}
                  value={typeof child === "string" ? child : child.value}
                >
                  {typeof child === "string" ? child : child.label}
                </MenuItem>
              );
            });
          } else {
            itemArray.push(
              <MenuItem
                key={index}
                value={typeof item === "string" ? item : item.value}
              >
                {typeof item === "string" ? item : item.label}
              </MenuItem>
            );
          }
        });
      }
      setItems(itemArray);
    };
    check();
  }, [list]);

  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={classes.formControl}
      sx={{ mt: 2, mb: 1, ...formControlSX }}
      disabled={disabled}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        label={label}
        variant="outlined"
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        labelId={`${name}-label`}
        name={name}
        value={value}
        onChange={handleSelect}
        input={<OutlinedInput label={label} />}
        endAdornment={endAdornment}
        renderValue={(selected) => {
          return (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((item) => (
                <Chip
                  key={item}
                  label={!listDict?.[item] ? item : listDict[item].label}
                />
              ))}
            </Box>
          );
        }}
        MenuProps={MenuProps}
        multiple
      >
        {items.map((item, index) => {
          return item;
        })}
      </Select>
    </FormControl>
  );
}
